import { useEffect, useRef } from "react";
import { solutionsContent } from "@/mocks/homepage";

export default function Solutions() {
  const cardsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("opacity-100", "translate-y-0");
            entry.target.classList.remove("opacity-0", "translate-y-8");
          }
        });
      },
      { threshold: 0.1 }
    );

    const cards = cardsRef.current?.children;
    if (cards) {
      Array.from(cards).forEach((card, index) => {
        card.classList.add("opacity-0", "translate-y-8", "transition-all", "duration-700");
        (card as HTMLElement).style.transitionDelay = `${index * 150}ms`;
        observer.observe(card);
      });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="solutions" className="py-20 md:py-28 bg-white">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="mb-16">
            <span className="inline-block text-dark-400 text-xs font-semibold uppercase tracking-widest mb-4">
              Naša rešenja
            </span>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-end">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-dark-900 leading-tight">
                Kompletna bezbednosna rešenja za vaš objekat
              </h2>
              <p className="text-dark-500 text-base sm:text-lg leading-relaxed">
                Od IP kamera i video interfona do kontrole pristupa i alarmnih sistema. Projektujemo, instaliramo i održavamo — sve na jednom mestu.
              </p>
            </div>
          </div>

          <div ref={cardsRef} className="grid grid-cols-2 gap-4 md:gap-6">
            {solutionsContent.map((sol, index) => (
              <div
                key={index}
                className="group relative rounded-3xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
              >
                <div className="relative aspect-[4/3] bg-dark-100">
                  <img
                    src={sol.image}
                    alt={sol.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-dark-900/90 via-dark-900/40 to-transparent"></div>

                  <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6 lg:p-8">
                    <div className="flex items-start gap-3 mb-2">
                      <div className="w-10 h-10 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-xl flex-shrink-0">
                        <i className={`${sol.icon} text-base text-white`}></i>
                      </div>
                      <div>
                        <span className="text-white/50 text-xs font-semibold uppercase tracking-wider">
                          {sol.subtitle}
                        </span>
                        <h3 className="text-lg md:text-2xl font-bold text-white mt-0.5">
                          {sol.title}
                        </h3>
                      </div>
                    </div>
                    <p className="text-white/70 text-xs md:text-sm leading-relaxed hidden sm:block">
                      {sol.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}